import {CodeFormType} from "./consts/consts";

const recoveryClasses = [`login__content--sent-mail`, `login__content--sent-phone`];

export default class Login {
  constructor(
    loginContainer,
    mainTabsView,
    secondsTabsView,
    emailLoginView,
    emailRegistrationView,
    phoneRegistrationView,
    phoneLoginView,
    codeView,
    errorView,
  ) {
    this._loginContainer = loginContainer;
    this._mainTabsView = mainTabsView;
    this._secondsTabsView = secondsTabsView;
    this._emailLoginView = emailLoginView;
    this._emailRegistartionView = emailRegistrationView;
    this._phoneRegistrationView = phoneRegistrationView;
    this._phoneLoginView = phoneLoginView;
    this._codeView = codeView;
    this._errorView = errorView;

    this._handleMainTabsClick = this._handleMainTabsClick.bind(this);
    this._handleSecondsTabsClick = this._handleSecondsTabsClick.bind(this);
    this._handleEmailLoginFormSubmit = this._handleEmailLoginFormSubmit.bind(this);
    this._handleEmailRegistrationFormSubmit = this._handleEmailRegistrationFormSubmit.bind(this);
    this._handlePhoneRegistrationFormSubmit = this._handlePhoneRegistrationFormSubmit.bind(this);
    this._handlePhoneLoginFormSubmit = this._handlePhoneLoginFormSubmit.bind(this);
    this._handleCodeFormSubmit = this._handleCodeFormSubmit.bind(this);
    this._handleCodeDigitInput = this._handleCodeDigitInput.bind(this);
    this._windowDOMContentLoadedHandler = this._windowDOMContentLoadedHandler.bind(this);
  }

  init() {
    this._mainTabsView.setMainTabsClickHandler(this._handleMainTabsClick);
    this._secondsTabsView.setSecondsTabsClickHandler(this._handleSecondsTabsClick);
    this._emailLoginView.setFormSubmitHandler(this._handleEmailLoginFormSubmit);
    this._emailRegistartionView.setFormSubmitHandler(this._handleEmailRegistrationFormSubmit);
    this._phoneRegistrationView.setFormSubmitHandler(this._handlePhoneRegistrationFormSubmit);
    this._phoneLoginView.setFormSubmitHandler(this._handlePhoneLoginFormSubmit);
    this._codeView.setFormSubmitHandler(this._handleCodeFormSubmit);
    this._codeView.setDigitInputHandler(this._handleCodeDigitInput);

    window.addEventListener(`DOMContentLoaded`, this._windowDOMContentLoadedHandler);
  }

  _resetView() {
    this._loginContainer.classList.remove(`login__content--phone`);
    this._loginContainer.classList.remove(`login__content--code`);
  }

  _changeMainContent(target) {
    if (target.classList.contains(`js-registration`)) {
      this._loginContainer.classList.add(`login__content--registration`);
    } else {
      this._loginContainer.classList.remove(`login__content--registration`);
    }

    this._resetView();
  }

  _changeSecondContent(target) {
    if (target.classList.contains(`js-by-phone`)) {
      this._loginContainer.classList.add(`login__content--phone`);
    } else if (target.classList.contains(`js-by-mail`)) {
      this._loginContainer.classList.remove(`login__content--phone`);
    }
  }

  _hideRecoveryInformMessage() {
    recoveryClasses.forEach((recoveryClass) => {
      if (this._loginContainer.classList.contains(recoveryClass)) {
        setTimeout(() => {
          this._loginContainer.classList.remove(recoveryClass);
        }, 3000);
      }
    });
  }

  _handleMainTabsClick(evt) {
    const target = evt.target;

    this._mainTabsView.changeTab(evt.target);
    this._changeMainContent(target);
  }

  _handleSecondsTabsClick(evt) {
    const target = evt.target;

    this._changeSecondContent(target);
  }

  _handleEmailLoginFormSubmit(evt) {
    this._emailLoginView.changeFormSubmitStatus(evt);
  }

  _handleEmailRegistrationFormSubmit(evt) {
    this._emailRegistartionView.changeFormSubmitStatus(evt);
  }

  _handlePhoneRegistrationFormSubmit(evt) {
    this._phoneRegistrationView.changeFormSubmitStatus(evt);
  }

  _handlePhoneLoginFormSubmit(evt) {
    this._phoneLoginView.changeFormSubmitStatus(evt);
  }

  _handleCodeFormSubmit(evt) {
    const loginFormType = this._loginContainer.classList.contains(`login__content--registration`)
      ? CodeFormType.REGISTRATION
      : CodeFormType.LOG_IN;
    const phoneNumber = loginFormType === CodeFormType.LOG_IN ? this._phoneLoginView.getPhoneNumber() : this._phoneRegistrationView.getPhoneNumber();
    this._codeView.setInputPhoneNumberValue(phoneNumber);
    this._codeView.changeFormSubmitStatus(evt);
  }

  _handleCodeDigitInput(evt, index) {
    this._codeView.inputCode(evt, index);
  }

  _windowDOMContentLoadedHandler() {
    this._hideRecoveryInformMessage();
  }
}
